import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/api";

const PANELS = [
  {
    image: IMAGES.residential,
    alt: "Aerial view of a residential plotted development",
    kicker: "Residential Plots",
    title: "Build a place for tomorrow.",
    points: [
      "Residential development opportunities",
      "Planned plot layouts",
      "Different plot sizes",
      "Connectivity-focused locations",
    ],
    cta: "Explore Residential Plots",
    to: "/properties?type=Residential",
    testId: "explore-residential-link",
  },
  {
    image: IMAGES.commercial,
    alt: "Modern commercial building representing commercial plot potential",
    kicker: "Commercial Plots",
    title: "Position your investment for future opportunities.",
    points: [
      "Commercial-use opportunities",
      "Strategic road connectivity",
      "Suitable locations for future development",
      "Investment-focused options",
    ],
    cta: "Explore Commercial Plots",
    to: "/properties?type=Commercial",
    testId: "explore-commercial-link",
  },
];

export default function ResComm() {
  return (
    <section data-testid="residential-commercial-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2">
          {PANELS.map((panel, i) => (
            <Reveal key={panel.kicker} delay={i * 0.12}>
              <div className="group relative flex min-h-[460px] flex-col justify-end overflow-hidden rounded-xl">
                <img
                  src={panel.image}
                  alt={panel.alt}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/55 to-navy/10" />
                <div className="relative p-8 lg:p-10">
                  <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-gold">{panel.kicker}</p>
                  <h3 className="mt-3 max-w-sm font-display text-3xl font-semibold leading-snug text-white">
                    {panel.title}
                  </h3>
                  <ul className="mt-5 space-y-2">
                    {panel.points.map((point) => (
                      <li key={point} className="flex items-center gap-2.5 text-sm text-white/80">
                        <Check className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                        {point}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={panel.to}
                    data-testid={panel.testId}
                    className="mt-7 inline-flex items-center gap-2 border-b-2 border-gold pb-1 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:text-gold"
                  >
                    {panel.cta}
                    <ArrowRight className="h-4 w-4" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
